<template>
  <el-popover
    placement="bottom"
    width="800"
    trigger="click"
    v-model="visible"
    popper-class="dg-dim-el-popover"
    >
    <dg-table
      v-if="visible"
      ref="popoverDimTable"
      apiCode="distDimcode"
      row-key="DIMCODE"
      :toolbarItems="tableModel.toolbarItems"
      :border="true"
      :tableItems="tableModel.tableItems"
      @rowClick="rowClick"
      @rowDblclick="rowClick"
      >
    </dg-table>
    <el-input
      slot="reference" 
      v-model="innerValue"
      v-cleaveEl="cleave || { notCleave: true }"
      type="text"
      :size="size || 'mini'"
      :style="Dgstyle"
      :maxlength="maxlength"
      :autosize="autosize"
      :prefix-icon="prefixIcon"
      :suffix-icon="suffixIcon"
      :readonly="readonly"
      :placeholder="placeholder || (disabled ? '' : '请输入')"
      :disabled="disabled"
      :clearable="true"
      @clear="clearInput"
    >
      <template v-if="prepend" slot="prepend"
        ><span>{{ prepend }}</span></template
      >
      <template v-if="append" slot="append"
        ><span>{{ append }}</span></template
      >
    </el-input>
  </el-popover>
</template>
<script lang="jsx">
export default {
  name: 'DgDimSelect',
  props: {
    /* 初始值 */
    value: {
      default: () => {
        return null
      },
    },
    cleave: {
      type: String,
      default: () => '',
    },
    size: {
      type: String,
      default: () => '',
    },
    maxlength: {
      type: String,
      default: () => '',
    },
    autosize: {
      default: () => {
        return null
      },
    },
    prefixIcon: {
      type: String,
      default: () => '',
    },
    suffixIcon: {
      type: String,
      default: () => '',
    },
    prepend: {
      type: String,
      default: () => '',
    },
    append: {
      type: String,
      default: () => '',
    },
    Dgstyle: {
      type: String,
      default: () => '',
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      visible: false,
      tableModel: {
        toolbarItems: [
          { value: 'DIMCODE', editer: 'input', placeholder: '维度编码' },
          { value: 'DIMNAME', editer: 'input', placeholder: '维度中文' }
        ],
        tableItems: [
          { 
            type: 'expand', 
            editer: 'DgTable',
            height: '290px',
            expandOptions: {
              toolbarItems: [
                { value: 'ROWCODE', editer: 'input', placeholder: '子项编码' },
                { value: 'ROWNAME', editer: 'input', placeholder: '子项中文' }
              ],
              tableItems: [
                { title: '子项编码', field: 'ROWCODE'},
                { title: '子项中文', field: 'ROWNAME'},
                { title: '父级编码', field: 'PARENTCODE'},
                { title: '拓展配置', field: 'CONF'},
                { title: '备注', field: 'REMARK'}
              ],
              border: true,
              apiCode: "sysDictMember",
              'row-key': "ID"
            }
          },
          { title: '维度编码', field: 'DIMCODE'},
          { title: '维度中文', field: 'DIMNAME'}
        ]
      }
    }
  },
  created () {
  },
  computed: {
    innerValue: {
      get() {
        this.updateValue(this.value)
        return this.formatValue(this.value)
      },
      set(val) {
        this.$emit('input', this.formatValue(val),this.item)
      },
    },
  },
  methods: {
    clearInput() {
      this.visible = false
      this.updateValue('')
    },
    rowClick(row) {
      this.visible = false
      this.updateValue(row.DIMCODE)
    },
    formatValue(val) {
      // 格式化？
      return val
    },
    updateValue(val) {
      this.$emit('updateValue', this.formatValue(val))
    },
  },
}
</script>
